import { VIDEO } from "@/lib/video";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PlayCircle, MousePointerClick, Download } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const VIDEO_URL = process.env.REACT_APP_TOUR_VIDEO_URL || "";

function embedUrl(url) {
  const yt = url.match(/(?:youtu\.be\/|v=|\/embed\/)([\w-]{6,})/);
  if (yt) return `https://www.youtube-nocookie.com/embed/${yt[1]}?rel=0`;
  const loom = url.match(/loom\.com\/(?:share|embed)\/([\w]+)/);
  if (loom) return `https://www.loom.com/embed/${loom[1]}`;
  return url;
}

export default function VideoSlot() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="how-it-works">
      <div className="grid lg:grid-cols-5 gap-8 items-center">
        <div className="lg:col-span-2">
          <span className="overline text-accent">See it in action</span>
          <h2 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight mt-1 mb-3">How it works</h2>
          <p className="text-muted-foreground mb-6">From your first question to inspection day — a 90-second narrated walk-through of what Futuregen Innovations does for registered managers, clinics and new providers.</p>
          <div className="flex flex-wrap gap-3">
            <Button asChild data-testid="take-tour-button"><Link to="/tour"><MousePointerClick className="w-4 h-4 mr-1.5" /> Take the interactive tour</Link></Button>
            <Button asChild variant="outline" data-testid="download-video-button"><a href={VIDEO.mp4} download="futuregen-walkthrough.mp4"><Download className="w-4 h-4 mr-1.5" /> Download video</a></Button>
          </div>
        </div>
        <div className="lg:col-span-3 flex justify-center">
          <div className="rounded-3xl overflow-hidden border border-border shadow-xl bg-black aspect-[9/16] w-full max-w-[360px] lg:max-w-[400px]" data-testid="video-slot">
            {VIDEO_URL ? (
              <iframe title="Futuregen Innovations walk-through" src={embedUrl(VIDEO_URL)} className="w-full h-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture" allowFullScreen data-testid="video-embed" />
            ) : (
              <video controls preload="none" playsInline poster={VIDEO.poster} className="w-full h-full" data-testid="video-player"
                onPlay={() => trackEvent("walkthrough_play")}>
                <source src={VIDEO.mp4} type="video/mp4" />
                Your browser can't play this video. <Link to="/tour">Take the interactive tour instead</Link>.
              </video>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
